import React, { useCallback, useEffect, useState,useMemo,useRef } from "react";
import { Card, Pagination, Button, ConfigProvider, Input,Select,Form,Modal,Col,message} from "antd";
import {getCurrentUser} from "@/utils/storage";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { useHistory } from "react-router-dom";
import "./index.scss";
import zh_CN from "antd/es/locale/zh_CN";
import {getStatus} from '@/utils/methods';
import ApproveModal from '@/components/ApproveModal'
const { TextArea } = Input
const { Search } = Input;
const { Option } = Select;


function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}
// const data = [
//   {text:"农业",id:1},
//   {text:"地产",id:2},
//   {text:"金融",id:3},
//   {text:"运输业",id:4},
//   {text:"餐饮",id:5},
//   {text:"制造业",id:6},
// ]
export default function ImbarkBase(props) {
  const modalRef = useRef([])

  const imageUrl = 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg';
  const [list, setList] = useState(
    [
      {
        label: "申请人姓名",
        name: "lgsjjx",
        value:"",
        type: "input",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "身份证号码",
        name: "lgsjjx",
        value:"",
        type: "input",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "创业行业",
        name: "lgsjjx",
        value:"",
        type: "select",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "创业地点",
        name: "lgsjjx",
        value:"",
        type: "input",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "企业地址",
        name: "lgsjjx",
        value:"",
        type: "input",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "联系方式",
        name: "lgsjjx",
        value:"",
        type: "input",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "创业项目资金支持",
        name: "lgsjjx",
        value:"",
        type: "input",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "创业项目贷款支持",
        name: "lgsjjx",
        value:"",
        type: "input",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "创业行业",
        name: "lgsjjx",
        value:"",
        type: "select",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "创业项目详情",
        name: "lgsjjx",
        value:"",
        type: "TextArea",
        require: true,
        placeholder: "请选择奖励奖项"
      },
      {
        label: "企业简介",
        name: "lgsjjx",
        value:"",
        type: "TextArea",
        require: true,
        placeholder: "请选择奖励奖项"
      },
  ]
  );
  const {searchValue} =props;
  const [currentPage, setCurrentPage] = useState(1); //当前页数
  const [total, setTotal] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  // const [searchValue, setSearchValue] = useState(""); //搜索框value值
  const [data, setData] = useState([]); 
  const [currentCityTwo, setCurrentCityTwo] = useState("");
  const [countyLevel, setCountyLevel] = useState(0); //眉山市或其他市
  const [succeed, setSucceed] = useState(0); //收藏
  const [succeedTwo, setSucceedTwo] = useState(0); //收藏
  const handlePage = (page, pageSize) => {
    setCurrentPage(page);
  };
  const history = useHistory();
  const handleJobDetail = (id) => {
    history.push(`entrepreneurship/ImbarkBaseDetails/${id}`);
  };
  const handleEnterprise = useCallback((e,id) => {
    e.stopPropagation()
    console.log('eeeeeeeeee',e);
    message.config({
      top: 50,
      duration: 1,
      maxCount: 1
    });
    if(!getCurrentUser()){
      message.error("还未登录，请先登录后再申请！");
      history.push("/login");
      return;
    }
    if(getCurrentUser().user_type!='2'){
      message.warn("非退役军人不可申请!")
    }else{
      getStatus().then(res=>{
        if(res===false){
          modalRef.current.showModal();
          return;
        }
    history.push(`entrepreneurship/AssistLication/${id}`);
  })
    }
    
    
  }, []);

  const handleChange = ()=>{
    
  }

  //改变searchValue
  const handleChangeSearchValue = useCallback((e) => {
    setCountyLevel(e);
  }, []);
  
  const renderBasicInfo = () =>{
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return list.map((item,index)=>{
      if(item.type == 'input'){
        return (
            <Col span={24}>
              <Form.Item {...formItemLayout} label={item.label}>
                  <Input
                    placeholder={"请输入姓名"}
                  />
              </Form.Item>
          </Col>
          )
      } else if(item.type == 'TextArea'){
        return (
          <Col span={24}>
            <Form.Item {...formItemLayout} label={item.label}>
                <TextArea
                  placeholder={"请输入姓名"}
                />
            </Form.Item>
        </Col>
        )
      }else if(item.type == 'select'){
        return (
        <Col span={24}>
          <Form.Item {...formItemLayout} label={item.label}>
          <Select defaultValue="lucy" onChange={handleChange}>
            <Option value="jack">Jack</Option>
            <Option value="lucy">Lucy</Option>
            <Option value="disabled" disabled>
              Disabled
            </Option>
            <Option value="Yiminghe">yiminghe</Option>
          </Select>
          </Form.Item>
        </Col>)
      }
      
    })
  }

  const initiaList = ()=>{
    let params = {
      size:6,
      current:currentPage,
      descs:'update_time',
      epalBaseName:props.searchValue
    }

    Http.get(Request.startBaseList(), {...params}, obj => {
      setData(obj.data?.records || []);
      setTotal(obj.data?.total || []);
  });
  }
  
  useEffect(() => { 
    initiaList()
  }, [currentPage,countyLevel,succeed,currentCityTwo,searchValue,succeedTwo]);
  console.log(searchValue)
  useEffect(() => {
    initiaList();
  }, [searchValue],);

  return (
    <div className={"ImbarkBase_app"}>
        <div className='getjob_major_thin'>
          {data.map((item, index) => {
          return (
            <div onClick={()=>{handleJobDetail(item.id)}} className="ImbarkBase_center">
              <ul className="getjob_center_total">
                <img src={item.epalBasePhoto} alt="" />
                <div className="getjob_center_total_top">
                  <p>{item.epalBaseName}</p>
                  <li>
                    <span>
                      基地地址：
                    </span>
                    <span className='getjob_Box_right'>
                      {item.epalBaseAddress}
                    </span>
                  </li>
                  <li>
                    <span>
                      联系电话：
                    </span>
                    <span className='getjob_Box_right'>
                      {item.epalBaseTel}
                    </span>
                  </li>
                  <li>
                    <span>
                      联系人：
                    </span>
                    <span className='getjob_Box_right'>
                      {item.epalBaseResponsible}
                    </span>
                  </li>
                  <div className="pagination_jump_buttom">
                    <Button onClick={(e)=>{handleEnterprise(e,item.id)}} className="pagination_footer_but" type="primary">申请入驻</Button>
                    <Button className="pagination_footer_but_right">基地详情</Button>
                  </div>
                </div>
              </ul>
            </div>
            );
          })}
        </div>

        <ConfigProvider locale={zh_CN}>
          <Pagination
            total={total}
            itemRender={itemRender}
            showQuickJumper={{
              goButton: <Button className={"pagination_jump"}>确定</Button>,
            }}
            showTotal={(total) => `共 ${total} 条`}
            onChange={handlePage}
            showSizeChanger={false}
            current={currentPage}
            defaultPageSize={6}
            style={{
              marginTop: 14,
              paddingRight: 24,
              display: "flex",
              justifyContent: "flex-end",
            }}
          />
        </ConfigProvider>
        <ApproveModal ref = {modalRef}/>
    </div>
  );
}
